<template>
  <div class="outdoor-pricelist">
    <div class="outdoor-pricelist__header" @click="closeModal()">
      <div class="outdoor-pricelist__header__left">
        <div class="search">
          <i class="adx-ic_search"></i>
          <input
            v-model="searchBoxValue"
            type="text"
            placeholder="Search placement or location ..."
          />
        </div>
        <a-dropdown-checkbox
          class="mediatype"
          :color="`pink`"
          :list="categoriesList"
          :loading="isLoadingCategory"
          @selected="selectedCategories"
          labelButton="Categories"
          :value.sync="selectedCategoryValue"
          :default="selectedCategoryValue"
        ></a-dropdown-checkbox>
        <a-dropdown-checkbox
          class="mediatype"
          :color="`pink`"
          :list="areaList"
          :loading="isLoadingArea"
          @selected="selectedAreas"
          labelButton="Area"
          :value.sync="selectedAreaValue"
          :default="selectedAreaValue"
        ></a-dropdown-checkbox>
        <a-multiple-dropdowon
          class="multiple-dropdown"
          :color="'pink'"
          :list="multipleOptions"
          :loading="isLoadingMultiple"
          @apply="applyMoreFilter"
          :key="'satu'"
          :title="`More Filters`"
          :isReset="isResetMultiDropdown"
        />
        <!-- <a-dropdown-checkbox
          class="mediatype"
          :color="`pink`"
          :list="mediaTypeList"
          @selected="selectedDropdown"
          labelButton="More Filter"
          :value.sync="selectedMediaTypeValue"
          :default="selectedMediaTypeValue"
        ></a-dropdown-checkbox>-->
        <div v-if="filtered" class="reset">
          <button class="btn-regular link" @click="resetFilter">Reset</button>
        </div>
      </div>
      <div class="outdoor-pricelist__header__right">
        <div class="outdoor-pricelist__header__right__sort">
          <div class="outdoor-pricelist__header__right__sort__label">Sort by:</div>
          <a-dropdown-sort
            class="outdoor-pricelist__header__right__sort__dropdown"
            :value.sync="selectedSortValue"
            :type="true"
            :options="sortOptions"
          ></a-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="outdoor-pricelist__table" @click="closeModal()">
      <div>
        <table class="table-pricelist">
          <thead>
            <tr>
              <th>
                <span class="btn-header"></span>
              </th>
              <th class="item-header mini-font">ITEMS</th>
              <th>
                <div class="items">
                  <span class="mini-font">CATEGORIES</span>
                </div>
              </th>
              <th>
                <div class="items">
                  <span class="mini-font">MIN ORDER</span>
                  <i class="adx-ic_info"></i>
                </div>
              </th>
              <th>
                <div class="items">
                  <span class="mini-font">PRICE</span>
                </div>
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in items" :key="index" @click.stop="selectedRow(item, index)">
              <td @click.stop="selectItem(item.id)">
                <span :class="isSelected(item.id) ? 'adx-ic_check' : 'adx-ic_plus'"></span>
              </td>
              <td>
                <div class="item-section">
                  <span class="placement-name subhead strong">{{ item.name }}</span>
                  <span class="location-name subhead">{{ displayLocation(item.location) }}</span>
                </div>
              </td>
              <td>
                <span class="min-period subhead">{{ item.location.category }}</span>
              </td>
              <td>
                <span
                  class="min-period subhead"
                >{{ minOrder(item.min_period, item.min_period_unit) }}</span>
              </td>
              <td>
                <span class="public-price subhead strong">{{ item.public_price | formatMoney }}</span>
              </td>
              <td v-if="item.future_prices.length > 0">
                <adx-tooltip
                  :text="getFuturePriceStart(item.future_prices[0].start)"
                  :isLong="true"
                >
                  <span slot="content">
                    <div class="futureprice">
                      <img src="/img/icons/ic-info-color-@3x 2.png" />
                    </div>
                  </span>
                </adx-tooltip>
              </td>
              <td v-else></td>
              <td>
                <a-menu-expansion
                  :itemID="item.id"
                  :lists="menuExpansionList"
                  @selected="selected"
                />
              </td>
            </tr>
            <tr></tr>
            <tr></tr>
            <tr></tr>
          </tbody>
          <tbody v-else-if="!isLoading && isEmpty" class="emptyLoadingState">
            <tr>
              <td colspan="100">
                <a-emptystate />
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading" class="emptyLoadingState">
            <tr>
              <td colspan="100">
                <a-loading />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <a-table text="Tooltip button"
        :items.sync="tableData"
        :loading.sync="isLoading"
        :isEmpty.sync="isEmpty"
        @selectedInput="selectedInput"
        @selectedCheckbox="selectedCheckbox"
        @selectedRow="selectedRow"
        @selected="selected">
      </a-table>-->
      <a-pagination
        v-if="!isLoading && !isEmpty"
        :selectedPage="selectedPage"
        :maxPage="maxPage"
        @change-page="selectPage"
      />
    </div>
    <a-modal
      v-if="isShowModal"
      @modal-close="toggleModal('isShowModal')"
      class="outdoor-pricelist__modal"
      :noTitle="true"
    >
      <div slot="content">
        <div class="outdoor-pricelist__modal__wrapper">
          <h1 class="medium-title title">Placement Detail</h1>
          <div class="outdoor-pricelist__modal__wrapper__header">
            <div class="outdoor-pricelist__modal__wrapper__header__top">
              <h1 class="regular-font placement-name">{{modal.placement}}</h1>
              <div>Price</div>
            </div>
            <div class="outdoor-pricelist__modal__wrapper__header__bottom">
              <div class="subhead media">{{modal.location}}</div>
              <h1 class="subhead price">{{modal.publicPrice | formatMoney}}</h1>
            </div>
          </div>
          <div class="outdoor-pricelist__modal__wrapper__body">
            <div class="outdoor-pricelist__modal__wrapper__body__tab">
              <ul>
                <router-link tag="li" :to="{name: 'outdoordetail'}" class="subhead">Detail</router-link>
                <router-link
                  tag="li"
                  :to="{name: 'outdoorcontentrest'}"
                  class="subhead"
                >Item Details</router-link>
                <router-link tag="li" :to="{name: 'outdooradress'}" class="subhead">Location Details</router-link>
                <router-link tag="li" :to="{name: 'outdoorfutureprice'}" class="subhead">Pricing</router-link>
                <router-link tag="li" :to="{name: 'outdoorimages'}" class="subhead">Images</router-link>
              </ul>
            </div>
            <div class="outdoor-pricelist__modal__wrapper__body__detail">
              <router-view :placementId="placementId" />
            </div>
            <div class="outdoor-pricelist__modal__wrapper__body__close">
              <button class="btn-large secondary" @click="toggleModal('isShowModal')">Close</button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-if="isShowConfirmationModal"
      @modal-close="toggleModal('isShowConfirmationModal')"
      class="outdoor-pricelist__confirmation-modal"
      :noTitle="true"
    >
      <div slot="content">
        <div class="outdoor-pricelist__confirmation-modal__wrapper">
          <h1 class="medium-title title">Remove item from Order?</h1>
          <p
            class="subhead"
          >It seems you have items on order summary, if you move to other channel all items will be removed, are you sure to continue?</p>
          <p class="subhead">Note: 1 channel only possible added as 1 campaign.</p>
          <div class="outdoor-pricelist__confirmation-modal__wrapper__buttons">
            <button
              type="button"
              class="btn-block secondary"
              @click.stop="redirectPage"
            >Continue, and Remove Item</button>
            <button
              type="button"
              class="btn-block primary"
              @click.stop="toggleModal('isShowConfirmationModal')"
            >Cancel</button>
          </div>
        </div>
      </div>
    </a-modal>
    <div v-if="isShowList" class="outdoor-pricelist__order">
      <i class="icon-close" @click="toggleModal('isShowList')"></i>
      <h1 class="smedium-title">Summary</h1>
      <div class="outdoor-pricelist__order__wrapper">
        <div
          class="outdoor-pricelist__order__wrapper__row"
          v-for="(selectedItem, index) in selectedItems"
          :key="index"
        >
          <div class="outdoor-pricelist__order__wrapper__row__left">
            <div class="placement subhead">{{selectedItem.name}}</div>
            <div class="location">{{selectedItem.location.name}}</div>
          </div>
          <div class="outdoor-pricelist__order__wrapper__row__right">
            <span class="price subhead">{{selectedItem.public_price | formatMoney }}</span>
            <span class="delete">
              <i @click="remoteSelectedItems(selectedItem.id)" class="icon-deleted"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="outdoor-pricelist__order__total">
        <div class="outdoor-pricelist__order__total__row">
          <div class="title subhead">PPN 10%</div>
          <div class="price subhead">{{totalPrice - totalPriceBeforeTax | formatMoney}}</div>
        </div>
        <div class="outdoor-pricelist__order__total__row">
          <div class="title subhead">Est. Total Price</div>
          <span class="price subhead">{{totalPrice | formatMoney }}</span>
        </div>
        <div
          class="outdoor-pricelist__order__total__note"
        >* This Price only estimation, before including Discount and etc</div>
      </div>
    </div>
    <div class="outdoor-pricelist__footer">
      <div class="outdoor-pricelist__footer__wrapper">
        <div class="outdoor-pricelist__footer__wrapper__left">
          <h1 class="selected">{{this.selectedItems.length}} Selected Advertising</h1>
        </div>
        <div class="outdoor-pricelist__footer__wrapper__right">
          <div class="outdoor-pricelist__footer__wrapper__right__total-price">
            <div class="total">
              <span>Est. Total Price</span>
            </div>
            <div class="price">
              <span>{{ totalPrice | formatMoney }}</span>
            </div>
          </div>
          <div class="outdoor-pricelist__footer__wrapper__right__buttons">
            <button class="btn-large secondary" @click="toggleModal('isShowList')">View List</button>
            <button
              class="btn-large primary save"
              @click="createCampaign">
              <div>
                <span class="color-white btn-title"> Create Campaign </span>
                <span><adx-loading-secondary-white class="sk-circle" v-if="isLoadingSave" /></span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";
import { globalMixins } from "@/lib/mixins/globalMixins";
import { helpers } from "@/lib/validation/";
import { mapGetters } from "vuex";

import LoadingSecondaryWhite from "@/components/Loading/Secondary-white";
import MultipleDropdown from "@/components/Dropdown/MultipleDropdown";
import Pagination from "@/components/Pagination";
import Tooltip from "@/components/Tooltip";

import { formatShortDate } from "@/lib/util";
import { formatMonetization } from "@/lib/filter";
import { fromArrayKeysName, fromKeys, mapListFilter } from "@/lib/transformer";

import {
  ASelectDropdown,
  ALoadingPrimary,
  AModal,
  APagination,
  ATable,
  ACheckboxDropdownCustom,
  AEmptySelection,
  AMenuExpansion,
  AMultipleDropdown
} from "ui-kit-v1";

export default {
  name: "adx-pricelist-outdoor",
  components: {
    "a-table": ATable,
    "a-pagination": APagination,
    "a-dropdown-sort": ASelectDropdown,
    "a-modal": AModal,
    "a-loading": ALoadingPrimary,
    "adx-loading-secondary-white": LoadingSecondaryWhite,
    "a-dropdown-checkbox": ACheckboxDropdownCustom,
    "a-emptystate": AEmptySelection,
    "a-menu-expansion": AMenuExpansion,
    "a-multiple-dropdowon": MultipleDropdown,
    "adx-tooltip": Tooltip
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      ids: [],
      items: [],
      maxPage: 1,
      selectedPage: 1,
      placementId: null,
      isShowModal: false,
      isShowList: false,
      isShowConfirmationModal: false,
      nextUrl: null,
      item: null,
      isLoading: false,
      isLoadingSave: false,
      isLoadingArea: false,
      isLoadingCategory: false,
      isLoadingMultiple: false,
      isEmpty: false,
      isResetMultiDropdown: false,
      searchBoxValue: null,
      selectedSortValue: "last_added",
      token_req: null,
      selectedItems: [],
      listItems: [],
      selectedMediaTypeValue: [],
      // selectedMediaTypeLabel: "",
      selectedCategoryValue: [],
      selectedAreaValue: [],
      selectedOrientations: [],
      selectedMinimumPeriods: [],
      multipleOptions: [],
      mediaTypeList: [],
      categoriesList: [],
      areaList: [],
      sortOptions: [
        {
          label: "Last Added",
          value: "last_added"
        },
        {
          label: "Highest Price",
          value: "price"
        },
        {
          label: "Lowest Price",
          value: "lowest_price"
        },
        {
          label: "Name",
          value: "name"
        }
      ],
      tableData: {
        checkbox: true,
        menu: [
          {
            id: 0,
            name: "Add to existing campaign",
            value: "S",
            items: []
          }
        ],
        head: [
          {
            title: "ID",
            type: "text",
            display: "display: none;"
          },
          {
            title: "ITEMS",
            type: "description"
          },
          {
            title: "MIN.ORDER",
            type: "text"
          },
          {
            title: "PRICE",
            type: "money"
          },
          {
            title: "FUTURE PRICE",
            type: "multipletext"
          }
        ],
        body: []
      },
      tableIds: [],
      modal: {
        location: null,
        placement: null,
        publicPrice: null
      },
      totalPrice: null,
      totalPriceBeforeTax: null,
      menuExpansionList: [
        {
          id: 0,
          name: "Add to existing campaign",
          value: "S",
          items: []
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      userId: "userId"
    }),
    filtered: function() {
      let filtered = false;
      if (this.selectedAreaValue.length > 0) {
        filtered = true;
      }
      if (this.selectedCategoryValue.length > 0) {
        filtered = true;
      }
      if (this.selectedOrientations.length > 0) {
        filtered = true;
      }
      if (this.selectedMinimumPeriods.length > 0) {
        filtered = true;
      }
      return filtered;
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.selectedPage = 1;
        this.loadData();
      });
    }, 500),
    selectedSortValue: function() {
      this.selectedPage = 1;
      this.loadData();
    },
    selectedPage: function() {
      this.loadData();
    },
    selectedCategoryValue: function() {
      this.$nextTick(() => {
        // this.selectedPage = 1;
        this.loadData();
      });
    },
    selectedAreaValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1;
        this.loadData();
      });
    },
    selectedOrientations: function() {
      this.$nextTick(() => {
        this.selectedPage = 1;
        this.loadData();
      });
    },
    selectedMinimumPeriods: function() {
      this.$nextTick(() => {
        this.selectedPage = 1;
        this.loadData();
      });
    }
  },
  beforeCreate() {},
  created() {
    this.loadFilter();
    this.loadCampaign();
    this.loadData();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  beforeRouteLeave(to, from, next) {
    if (this.selectedItems.length > 0 && to.name != "campaigneditoredit") {
      this.toggleModal("isShowConfirmationModal");
      this.nextUrl = to.name;
    } else {
      next();
    }
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      this.isEmpty = false;
      this.tableIds = [];
      let params = {
        page: this.selectedPage,
        search: this.searchBoxValue,
        sort: this.selectedSortValue,
        categories: this.selectedCategoryValue.join(`,`) || undefined,
        areas: this.selectedAreaValue.join(`,`) || undefined,
        orientations: this.selectedOrientations.join(`,`) || undefined,
        min_periods: this.selectedMinimumPeriods.join(`,`) || undefined
        // media_type: this.selectedMediaTypeValue.join(",")
      };

      let random_numb = Math.random()
      this.token_req = random_numb;
      
      const { data, status } = await api.get(restEdge.outdoorPricelist, {
        params: params,
        needToken: true,
        useRestEdge: true
      });
      if (status === 200) {
        if (random_numb == this.token_req) {
          this.listItems = data.results;
          this.tableData.body = await data.results.map(result => {
            this.tableIds.push(result.id);
            let rowData = {
              values: [
                { value: result.id, display: "display: none;" },
                {
                  header: true,
                  items: [
                    { value: result.name },
                    { value: result.location.name }
                  ],
                  labelLink: true,
                  label: "View Detail"
                },
                {
                  value: this.pluralize(result.min_period, result.min_period_unit)
                },
                { value: result.public_price }
              ]
            };

            if (result.future_prices.length) {
              rowData.values.push({
                items: [
                  {
                    value: formatMonetization(
                      result.future_prices[0].public_price
                    )
                  },
                  {
                    value:
                      "Applied " + formatShortDate(result.future_prices[0].start)
                  }
                ]
              });
            } else {
              rowData.values.push({
                items: [{ value: "-" }]
              });
            }

            return rowData;
          });

          this.items = data.results;
          this.maxPage = data.maxPage;
          if (!this.tableData.body.length) this.isEmpty = true;
        }
      } else {
        this.showNotificationAlert(
          "Error",
          "Ops, something went wrong.",
          "danger"
        );
      }

      this.isLoading = false;
    },
    async loadCampaign() {
      let params = {
        channel: "outdoor"
      };
      const { data, status } = await api.get(restEdge.getAllCampaignChannel, {
        params: params,
        needToken: true,
        useRestEdge: true
      });

      if (status === 200) {
        this.tableData.menu[0].items = data.map(x => ({
          label: x.name,
          value: "expired",
          id: x.id
        }));
        this.menuExpansionList[0].items = data.map(x => ({
          name: x.name,
          id: x.id
        }));
      } else {
        this.showNotificationAlert(
          "Error",
          "Ops, something went wrong.",
          "danger"
        );
      }
    },
    async loadFilter() {
      const params = { channel: "outdoor" };
      this.loadingFilterState(true)
      const { data, status } = await api.get(restEdge.outdoorPricelistFilter, {
        params: params,
        needToken: true,
        useRestEdge: true
      });
      if (status === 200) {
        this.categoriesList = mapListFilter({
          obj: data.categories,
          id: `id`,
          value: `value`,
          label: `name`
        });
        
        this.areaList = mapListFilter({
          obj: data.areas,
          id: `id`,
          value: `id`,
          label: `name`
        });
        this.orientationList = mapListFilter({
            obj: data.orientations,
            id: `id`,
            value: `value`,
            label: `name`
        });
        this.periodList = mapListFilter({
            obj: data.periods,
            id: `id`,
            value: `value`,
            label: `name`
        });
        const orientationList = {
          type: "checkbox",
          title: "Orientation",
          list: this.orientationList
        };
        const periodList = {
          type: "checkbox",
          title: "Minimum Order",
          list: this.periodList
        };
        this.multipleOptions.push(orientationList);
        this.multipleOptions.push(periodList);
        this.loadingFilterState(false)
      } else {
        this.loadingFilterState(false)
        this.showNotificationAlert(
          "Error",
          "Ops, something went wrong.",
          "danger"
        );
      }
    },
    loadingFilterState(value){
      this.isLoadingArea = value
      this.isLoadingCategory = value
      this.isLoadingMultiple = value
    },
    async selectedRow(item, index) {
      this.toggleModal("isShowModal");
      this.placementId = this.tableIds[index];
      this.modal.placement = item.name;
      this.modal.location =
        item.location != null || item.location != undefined
          ? item.location.name
          : "-";
      this.modal.publicPrice = item.public_price;

      // this.modal.placement = item.values[1].items[0].value
      // this.modal.location = item.values[1].items[1].value
      // this.modal.publicPrice = item.values[3].value
    },
    toggleModal(value) {
      this.$data[value] = !this.$data[value];
      if (!this.showModal) {
        this.$router.push({ name: "outdoordetail" });
      }
    },
    selectPage(item) {
      this.selectedPage = item;
    },
    closeModal(){
      this.isShowList = false
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }

      return `${value} ${label}`;
    },
    selectedInput(index, item, value) {
      let val = this.tableData.body[index].values[3].value;
      let bottomPrice = this.tableData.body[index].values[2].value;

      //calculating discount inputed to given price
      this.tableData.body[index].values[5].value = val - (value / 100) * val;

      //validating if given price npt lower than bottom price
      if (this.tableData.body[index].values[5].value < bottomPrice) {
        this.tableData.body[index].values[4].isError = true;
      } else {
        this.tableData.body[index].values[4].isError = false;
      }
      return (this.discount = parseInt(value));
    },
    selectedCheckbox(ids) {
      this.selectedItems = this.listItems.filter(item => ids.includes(item.id));
      this.computeTotalPrice();
    },
    remoteSelectedItems(id) {
      this.selectedItems = this.selectedItems.filter(item => item.id !== id);
      this.computeTotalPrice();
    },
    computeTotalPrice() {
      this.totalPrice = 0;
      this.totalPriceBeforeTax = 0;
      if (this.selectedItems.length) {
        this.totalPriceBeforeTax = this.selectedItems.reduce(
          (total, item) => total + item.public_price,
          0
        );
        this.totalPrice = (this.totalPriceBeforeTax * 110) / 100;
      }
    },
    async createCampaign() {
      this.isLoading = true;
      this.isLoadingSave = true;
      if (this.selectedItems.length) {
        let body = {
          campaign_medias: [],
          owner: this.userId,
          channel: this.selectedItems[0].location.channel
        };
        console.log(this.selectedItems)
        this.selectedItems.forEach(item => {
          if (!body.campaign_medias.length) {
            body.campaign_medias.push({
              media_type: item.location.media_type,
              list_item: [item.id]
            });
          } else {
            let current_campaign_media = body.campaign_medias.filter(
              media => media.media_type == item.location.media_type
            );

            if (current_campaign_media.length > 0) {
              current_campaign_media[0].list_item.push(item.id);
            } else {
              body.campaign_medias.push({
                media_type: item.location.media_type,
                list_item: [item.id]
              });
            }
          }
        });

        const { data, status } = await api.post(
          restEdge.createCampaignChannel,
          body,
          { needToken: true, useRestEdge: true }
        );
        if (status === 200) {
          this.$router.push({
            name: "campaigneditoredit",
            params: { id: data.id }
          });
        } else {
          this.showNotificationAlert(
            "Error",
            "Ops, something went wrong.",
            "danger"
          );
        }
      } else {
        this.showNotificationAlert(
          "Error",
          "Please select a placement.",
          "danger"
        );
      }
      this.isLoading = false;
      this.isLoadingSave = false;
    },
    async selected(event) {
      const item = this.listItems.filter(x => x.id == event.item_id).pop();

      const body = {
        campaign_medias: [
          {
            media_type: item.location.media_type.toLowerCase(),
            list_item: [item.id]
          }
        ]
      };

      const { data, status } = await api.patch(
        restEdge.patchCampaignChannel(event.items.id),
        body,
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.showNotificationAlert(
          "Success",
          `Data successfully added to campaign ${data.name}!`,
          "success"
        );
      } else if (status == 400) {
        this.showNotificationAlert(
          "Error",
          "Placement already exist.",
          "danger"
        );
      } else {
        this.showNotificationAlert(
          "Error",
          "Ops, something went wrong.",
          "danger"
        );
      }
    },
    selectItem(id) {
      if (this.ids.includes(id)) {
        let index = this.ids.indexOf(id);
        this.ids.splice(index, 1);
        this.selectedItems = this.selectedItems.filter(function(value, index, arr){ return value.id !== id;});
      } else {
        this.ids.push(id);
        this.selectedItems.push(...this.listItems.filter(item =>
          id == item.id
        ))
      }
      
      this.computeTotalPrice();
    },
    minOrder(minPeriod, minPeriodPlan) {
      return `${minPeriod} ${minPeriodPlan}`;
    },
    getFuturePriceStart(date) {
      let start = moment(date, "YYYY-MM-DD");
      return `Future Price Applied on ${start.format("DD MMM YYYY")}`;
    },
    isSelected(id) {
      return this.ids.includes(id);
    },
    selectedCategories(items) {
      this.selectedCategoryValue = items;
    },
    selectedAreas(items) {
      this.selectedAreaValue = items;
    },
    redirectPage() {
      this.selectedItems = [];
      this.$router.push({ name: this.nextUrl });
    },
    resetFilter() {
      this.selectedAreaValue = [];
      this.selectedCategoryValue = [];
      this.selectedOrientations = [];
      this.selectedMinimumPeriods = [];
      this.isResetMultiDropdown = true;
    },
    applyMoreFilter(result) {
      // Orientation filter
      let orientation = result.filter(obj => obj.title === "Orientation")[0];
      if (orientation) {
        this.selectedOrientations = orientation.result;
      }
      // Period filter
      let period = result.filter(obj => obj.title === "Minimum Order")[0];
      if (period) {
        this.selectedMinimumPeriods = period.result;
      }

      this.$nextTick(() => {
        this.isResetMultiDropdown = false;
        this.selectedPage = 1;
        this.loadData();
      });
    },
    displayLocation(data) {
      let name = data.name
      if (data.location_detail) {
        if (data.location_detail.area) {
          name += `, ${data.location_detail.area.name}`
        }
        if (data.location_detail.city) {
          name += ` ${data.location_detail.city.name}`
        }
      }

      return name
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>

<style lang="scss">
@import "~@/styles/variables";
// @import '~@/styles/mixins';
.outdoor-pricelist {
  tbody {
    tr {
      cursor: pointer;
      td {
        .inputed-type {
          width: 140px !important;
        }

        .money {
          text-align: left !important;
          span {
            color: #ff2d55;
            font-size: 15px;
            font-weight: bold;
          }
        }

        .text {
          font-size: 15px;
        }

        .description {
          max-width: unset !important;

          b {
            font-size: 17px;
          }
          span {
            font-size: 15px;
          }
          .label_hover {
            span {
              font-size: 15px;
            }
          }
        }

        .multiple-text {
          div {
            &:nth-child(1) {
              span {
                font-size: 15px;
                color: $warm-grey;
              }
            }

            &:nth-child(2) {
              span {
                font-size: 12px;
                color: $sunflower-yellow;
              }
            }
          }
        }

        input {
          border: 1px solid lightgray;
          border-radius: 4px;
          padding: 8px;
          margin-bottom: 8px;
          width: 140px;
          // max-width: 130px;
        }

        .error-message {
          width: 140px !important;
        }
      }
    }
  }

  .mediatype {
    margin-right: 8px;
  }

  .table input {
    width: 140px !important;
  }

  .table table tbody tr td .multiple-text div {
    margin-bottom: 2px !important;
  }

  .status-label .label {
    margin: 0px !important;
  }

  // .modal__content {
  //   // width: 50%;
  //   // max-height: 550px;
  //   // overflow: auto;
  // }

  .menuexpansion__level1__item {
    width: 230px;
  }
  .multiple-dropdown {
    z-index: 1;
    .wrapper_content__menu__wrapper__sub {
      max-height: 150px;
      overflow: auto;
    }
  }

  .menuexpansion__level2__wrapper {
    overflow-x: hidden;

    li:first-child {
      border-bottom: none;
    }

    .status-label {
      white-space: normal;

      .label {
        background-color: transparent;
        color: $black;
        width: 150px;
        word-wrap: break-word;
      }
    }
  }
}
.futureprice {
  height: 16px;
  width: 16px;
  margin-top: 7px;
}
</style>
